import React from 'react';
import css from './css.module.less';
import { Dropdown, Menu } from 'antd';
import { Icon } from '@/src/tools/icon';
import { modal } from 'src/utils/Modal';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { SyncOutlined } from '@ant-design/icons';

export const TRANSLATION_STATUS = {
  translationOn: 'translationOn',
  translationOff: 'translationOff',
};

const AITranslationDropDown = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { handleOnConfirm, translationEnabled, loading } = props;
  const _handleOnConfirm = (e) => {
    if (e?.key === TRANSLATION_STATUS.translationOn) {
      if (translationEnabled) return;
      modal.error({
        title: 'Enable Translation',
        content: getI18n('general.translationOnTip'),
        onCancel: () => {
          //do nothing
        },
        onCancelText: getI18n('general.cancel'),
        onOk: () => {
          handleOnConfirm(true);
        },
        onOkText: 'Overwrite',
        containerStyle: { width: '600px' },
      });
    } else {
      if (!translationEnabled) return;
      handleOnConfirm(false);
    }
  };
  return (
    <div>
      <Dropdown
        getPopupContainer={() => document.body}
        overlay={
          <Menu onClick={_handleOnConfirm}>
            <Menu.Item key={TRANSLATION_STATUS.translationOn}>
              {getI18n('general.translationOn')}
            </Menu.Item>
            <Menu.Item key={TRANSLATION_STATUS.translationOff}>
              {getI18n('general.translationOff')}
            </Menu.Item>
          </Menu>
        }
        disabled={loading}
        placement='bottomCenter'>
        <div
          className={`${css.dropdownButton} ${
            loading ? css.dropdownButtonDisabled : ''
          }`}>
          <div className={css.dropdownLeft}>
            {translationEnabled ? (
              <span className={css.translationOn}>
                <SyncOutlined rev={undefined} style={{ marginRight: '8px' }} />
                {getI18n('general.translationOn')}
              </span>
            ) : (
              <span>
                <SyncOutlined rev={undefined} style={{ marginRight: '8px' }} />
                {getI18n('general.translationOff')}
              </span>
            )}
          </div>
          <div className={css.dropdownRight}>
            <Icon type='icondown' className={css.icon} />
          </div>
        </div>
      </Dropdown>
    </div>
  );
};

export default AITranslationDropDown;
